import React, { useState } from 'react';
import { SocialType } from '../../redux/auth/authTypes';

type AppProps = {
  social?: SocialType;
}

type SocialTypePayload = {
  linkedIn: string;
  facebook: string;
  twitter: string;
  skype: string;
  website: string;
}

const Social = ({ social }: AppProps) => {
  const [socialInfo, setSocialInfo] = useState<SocialTypePayload>({
    linkedIn: 'Ankit Saxena',
    facebook: 'https://facebook.com/ankit.saxena5095',
    twitter: 'Zombie.js',
    skype: 'AnkitSTCO',
    website: 'http://theglobalpassenger.com'
  });


  /* const {
    linkedIn,
    facebook,
    twitter,
    skype,
    website
  } = socialInfo; */



  let linkedIn = social?.linkedin;
  let skype = social?.skype_id;
  let twitter = social?.twitter_id

  return (
    <div className="w-75">
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={linkedIn ? "active" : ""}
          >LinkedIn</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={linkedIn}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        {/* <div className="float-label">
          <label htmlFor="name"
            className={facebook ? "active" : ""}
          >Facebook</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={facebook}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div> */}
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={twitter ? "active" : ""}
          >Twitter</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={twitter}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={skype ? "active" : ""}
          >SkypeID</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={skype}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        {/* <div className="float-label">
          <label htmlFor="name"
            className={website ? "active" : ""}
          >Websitee</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={website}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div> */}
      </div>
    </div>
  )
};

export default Social;